import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { authInterceptor } from '@/pages/auth/auth.interceptor';
import { encryptionInterceptor } from '@/pages/auth/encryption.interceptor';

// Swiggy-style green primary (#60B246) — overrides Aura's default emerald.
const GrowHighGreen = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#f0f8eb',
      100: '#dcefcb',
      200: '#c2e3a6',
      300: '#a4d67c',
      400: '#84c658',
      500: '#60b246',
      600: '#4f9b3a',
      700: '#3e7c2e',
      800: '#2f5e23',
      900: '#234718',
      950: '#112a0b'
    }
  }
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      appRoutes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled'
      }),
      withEnabledBlockingInitialNavigation()
    ),

    provideHttpClient(
      withFetch(),
      withInterceptors([authInterceptor, encryptionInterceptor]) // JWT first, then optional payload encryption
    ),

    provideAnimationsAsync(),

    providePrimeNG({
      theme: {
        preset: GrowHighGreen,
        options: { darkModeSelector: '.app-dark' }
      }
    })
  ]
};